import { createContext, useContext, useEffect, useState } from "react";

const FilterCtx = createContext(null);

const PRICE_DEFAULT_MIN = 0;
const PRICE_DEFAULT_MAX = 10000;

export function FilterProvider({ children }) {
  const [open, setOpen] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("hb_filter_open") : null;
    if (saved !== null) return saved === "1";
    return false; // closed by default — opened via Filters button
  });

  const [category, setCategory] = useState("All");
  const [collection, setCollection] = useState("All");
  const [priceMin, setPriceMin] = useState(PRICE_DEFAULT_MIN);
  const [priceMax, setPriceMax] = useState(PRICE_DEFAULT_MAX);
  const [sort, setSort] = useState("catalogue");

  useEffect(() => {
    localStorage.setItem("hb_filter_open", open ? "1" : "0");
  }, [open]);

  const reset = () => {
    setCategory("All");
    setCollection("All");
    setPriceMin(PRICE_DEFAULT_MIN);
    setPriceMax(PRICE_DEFAULT_MAX);
    setSort("catalogue");
  };

  const isFiltering =
    category !== "All" ||
    collection !== "All" ||
    priceMin > PRICE_DEFAULT_MIN ||
    priceMax < PRICE_DEFAULT_MAX;

  const buildParams = () => {
    const p = { sort };
    if (category !== "All") p.category = category;
    if (collection !== "All") p.collection = collection;
    if (priceMin > PRICE_DEFAULT_MIN) p.min_price = priceMin;
    if (priceMax < PRICE_DEFAULT_MAX) p.max_price = priceMax;
    return p;
  };

  return (
    <FilterCtx.Provider
      value={{
        open, setOpen,
        category, setCategory,
        collection, setCollection,
        priceMin, setPriceMin,
        priceMax, setPriceMax,
        sort, setSort,
        reset,
        isFiltering,
        buildParams,
        PRICE_DEFAULT_MIN, PRICE_DEFAULT_MAX,
      }}
    >
      {children}
    </FilterCtx.Provider>
  );
}

export const useFilters = () => {
  const ctx = useContext(FilterCtx);
  if (!ctx) throw new Error("useFilters must be inside FilterProvider");
  return ctx;
};
